import { lightBlue } from 'common/styles/colors';
import styled from 'styled-components';

export const FormContainer = styled.div<{
  $showBackground: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin: 5px 10px;
  border-radius: 8px;
  background: ${props => (props.$showBackground ? lightBlue : 'none')};
`;
